import { addItemButtonSelectors, getSelectorAttribute } from '@vy/app-selectors';
import type { MenuItem } from './menu-types/menu-item';
import type { MenuItemsHeader } from './menu-types/menu-items-header';

type MenuActions = {
  onFixedPlanClick: () => void;
  onUsagePlanClick: () => void;
  onPerUnitPlanClick: () => void;
  onPromotionsPlanClick: () => void;
  onVolumeClick: () => void;
  onSubscriptionClick: () => void;
  onCommissionClick: () => void;
  onCommercialTermsClick: () => void;
};

type MenuItemProps = Omit<MenuItem, 'id' | 'onClick' | 'label'>;

type MenuItemsProps = {
  fixedFeeItem?: MenuItemProps;
  subscriptionFeeItem?: MenuItemProps;
  tieredPricingItem?: MenuItemProps;
  perUnitPricingItem?: MenuItemProps;
  volumeBasedTiersItem?: MenuItemProps;
  promotionsItem?: MenuItemProps;
  commissionItem?: MenuItemProps;
  commercialTermsItem?: MenuItemProps;
};

export const getMenuItemsWithHeaders = (
  menuActions: MenuActions,
  menuItemsProps?: MenuItemsProps,
): MenuItemsHeader => ({
  ['Select Pricing Model']: [
    {
      ...menuItemsProps?.fixedFeeItem,
      id: 1,
      label: 'Fixed fees item',
      onClick: menuActions.onFixedPlanClick,
      ...getSelectorAttribute(addItemButtonSelectors.menuItems.fixedFeeItem),
    },
    {
      ...menuItemsProps?.subscriptionFeeItem,
      id: 2,
      label: 'Subscription item',
      onClick: menuActions.onSubscriptionClick,
      ...getSelectorAttribute(addItemButtonSelectors.menuItems.subscriptionFeeItem),
    },
    {
      ...menuItemsProps?.tieredPricingItem,
      id: 3,
      label: 'Tiered pricing item',
      onClick: menuActions.onUsagePlanClick,
      ...getSelectorAttribute(addItemButtonSelectors.menuItems.tieredPricingItem),
    },
    {
      ...menuItemsProps?.perUnitPricingItem,
      id: 4,
      label: 'Per unit pricing item',
      onClick: menuActions.onPerUnitPlanClick,
      ...getSelectorAttribute(addItemButtonSelectors.menuItems.perUnitPricingItem),
    },
    {
      ...menuItemsProps?.volumeBasedTiersItem,
      id: 5,
      label: 'Volume based tiers',
      onClick: menuActions.onVolumeClick,
      ...getSelectorAttribute(addItemButtonSelectors.menuItems.volumeBasedTiersItem),
    },
    {
      ...menuItemsProps?.promotionsItem,
      id: 6,
      label: 'Promotions',
      onClick: menuActions.onPromotionsPlanClick,
      ...getSelectorAttribute(addItemButtonSelectors.menuItems.promotionsItem),
    },
    {
      ...menuItemsProps?.commissionItem,
      id: 7,
      label: 'Commission',
      onClick: menuActions.onCommissionClick,
      ...getSelectorAttribute(addItemButtonSelectors.menuItems.commissionItem),
    },
    {
      ...menuItemsProps?.commercialTermsItem,
      id: 8,
      label: 'Commercial terms',
      onClick: menuActions.onCommercialTermsClick,
      ...getSelectorAttribute(addItemButtonSelectors.menuItems.commercialTermsItem),
    },
  ],
});
